import { ConditionGroup } from 'api/models/FieldTemplate';
import { useRecoilValue } from 'recoil';
import { evaluateConditionGroup } from 'routes/Form/conditionUtils';
import { selectedPatientState } from 'state';
import { formsFieldTemplates } from 'state/formState';

interface UseEvaluateConditionsProps {
  conditionGroup?: ConditionGroup;
  values: any;
}
export default function useEvaluateConditions({
  conditionGroup,
  values,
}: UseEvaluateConditionsProps): boolean {
  const patient = useRecoilValue(selectedPatientState);
  const fieldTemplates = useRecoilValue(formsFieldTemplates);

  return evaluateConditionGroup({
    rootGroup: conditionGroup,
    values,
    fieldTemplates,
    patient,
  });
}
